/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 33 32"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.5 28a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-6.667a1 1 0 1 0-2 0V27h-22v-5.667a1 1 0 1 0-2 0V28Z"
    />
    <path
      fill="currentColor"
      d="M9.126 11.293a1 1 0 1 0 1.415 1.414l4.96-4.96v13.586a1 1 0 1 0 2 0V7.747l4.959 4.96a1 1 0 0 0 1.414-1.414l-6.667-6.667a1 1 0 0 0-1.414 0l-6.667 6.667Z"
    />
  </svg>
)
const Memo = memo(SvgUpload)
export default Memo
